import { initDetections, mobileCheck, is_chrome, is_explorer, is_explorer_11, is_firefox, is_safari, is_edge, is_opera, xsMax, smMax, mdMax, lgMax, smMin, mdMin, lgMin, xlMin, mobile } from './detections.js';
import { initQuestionSliderResults } from './question-slider-results.js';

jQuery(document).ready(function($){
    // browser sniffing
    // window size variables (bootstrap 4)
    initDetections();
    initQuestionSliderResults();

    // Navigation
    var navbar = $('.header-nav'),
        dropdownOpen = false,
        mobileNavOpened = false;

    // Hide all dropdowns
    function closeDropdowns() {
        navbar.removeClass('dropdown-open');

        $('.dropdown-panel').each(function() {
            $(this).removeClass('open');

            $(this).find('[tabindex]').attr('tabindex', '-1');
        });
        $('.panel-toggle').each(function() {
            $(this).removeClass('dropdown-open');
            $(this).attr('aria-expanded','false');
        });
    }

    // Sub Nav
    $('.menu-item-has-children').each(function() {
        var parent = $(this),
            toggle = $(this).find('.panel-toggle');

        $(toggle).on('click', function(e) {
    		var panel = '#' + $(this).attr('aria-controls');

            // prevent default
            e.preventDefault();

            // hide other dropdowns
            $('.panel-toggle').not(toggle).attr('aria-expanded','false');
            $('.panel-toggle').not(toggle).removeClass('dropdown-open');
            $('.dropdown-panel').not(panel).removeClass('open').find('[tabindex]').attr('tabindex', '-1');

            // toggle aria expanded
            toggle.attr('aria-expanded','true');

            // close dropdown panel if click on the same trigger twice
            if(toggle.hasClass('dropdown-open')) {
                closeDropdowns();
            } else {
                // add appropriate classes to open the dropdown
                toggle.addClass('dropdown-open');
                navbar.addClass('dropdown-open');
                $(panel).addClass('open').find('[tabindex]:visible').attr('tabindex', '0');

                setTimeout(function () {
                    if (e.originalEvent.pointerId < 0) {
                        $(panel).find('[tabindex]:visible:not(.mobileBack)').first().get(0).focus();
                    }
                }, 100);
            }
    	});
    });

    // Open mobile nav
    function openMobileNav() {
        var mainNav = $('#mainNav');

        mainNav.find('.mobile-search').show();
        mainNav.find('.mobile-utility').show();

        mainNav.find('li.top > [tabindex]').attr('tabindex', '0');

        navbar.addClass('mobile-nav-open');
        $('body, html').addClass('mobile-nav-open');
        mainNav.addClass('open');
        $('#menuToggle').each(function(){
            $(this).attr('aria-expanded','true');
            $(this).addClass('open');
        });

        mobileNavOpened = true;
    }

    // Close mobile nav
    function closeMobileNav() {
        var mainNav = $('#mainNav');

        closeDropdowns();

        navbar.removeClass('mobile-nav-open');
        $('body, html').removeClass('mobile-nav-open');
        mainNav.removeClass('open');
        $('#menuToggle').each(function(){
            $(this).attr('aria-expanded','false');
            $(this).removeClass('open');
        });

        mainNav.find('.mobile-search').hide();
        mainNav.find('.mobile-utility').hide();

        if (lgMax) {
            mainNav.find('li.top > [tabindex]').attr('tabindex', '-1');
        } else {
            mainNav.find('li.top > [tabindex]').attr('tabindex', '0');
        }

        mobileNavOpened = false;
    }

	// Toggle mobile nav
	$('#menuToggle').each(function(){
		$(this).click(function(e){

            if(mobileNavOpened == false) {
    			openMobileNav();

                if (e.originalEvent.pointerId < 0) {
                    $('#mainNav li.top > [tabindex]').first().get(0).focus();
                }
    		} else {
                closeMobileNav();
    		}
		});
	});

    // Close subnavs on mobile back click
    $('.mobileBack').each(function(){
        $(this).on('click', function(){
            closeDropdowns();
        });
    });

    // Nav adjustments on scroll
	$(window).scroll(function() {
        var scrollPosition = $(window).scrollTop();

        if(scrollPosition > 200) {
            closeDropdowns();
        }
    });

    // close dropdowns on body click
    $('body').on('click', function(event){
        if((!$(event.target).closest('.main-nav-wrapper').length)) {
            closeDropdowns();
        }
    });

    // collapse/edpand Secondary Nav
    function toggleSecondaryNav() {
        if(mdMax) {
            $('#secondary-nav-links-toggle').each(function(){
                $(this).attr('aria-expanded','false');
                $(this).addClass('collapsed');
            });
            $('#secondary-nav-links').addClass('collapse');
        } else {
            $('#secondary-nav-links-toggle').each(function(){
                $(this).attr('aria-expanded','true');
                $(this).removeClass('collapsed');
            });
            $('#secondary-nav-links').removeClass('collapse').removeClass('show');
        }
    };
    toggleSecondaryNav();

    // Nav adjustments on resize
	$(window).resize(function() {
        closeDropdowns();
        closeMobileNav();
        toggleSecondaryNav();
    });

    //ensure mobile nav starts closed
    closeMobileNav();

    //keyboard events
    $('body').on('keyup', function (e) {
        var target = $(e.target);

        if (target.closest('.main-nav-wrapper').length > 0) {

            if (e.which == 27) { //esc

                if (target.closest('.dropdown-panel').length > 0) {
                    let panel = target.closest('.dropdown-panel');

                    closeDropdowns();

                    if (lgMax) {
                        $('[aria-controls="' + panel.attr('id') + '"]').get(0).focus();
                    }
                } else if (lgMax) {
                    closeMobileNav();

                    $('button.menu-toggle').get(0).focus();
                }
            }
        } else {
            closeDropdowns();

            if (lgMax) {
                closeMobileNav();
            }
        }
    });

	// Magnific Popup
    //check if we've included the plugin first
    if(typeof $.fn.magnificPopup == 'function') {
        // Magnific popup videos
    	$(".mfp-video").magnificPopup({
    		type: 'iframe',
    		closeMarkup: '<span class="video-close icon-menu-close mfp-close"></span>',
            iframe: {
                patterns: {
                    youtube: {
                        index: 'youtube.com/',
                        id: function(url) {
                            var m = url.match(/[\\?\\&]v=([^\\?\\&]+)/);
                            if ( !m || !m[1] ) return null;
                            return m[1];
                        },
                        src: '//www.youtube.com/embed/%id%?autoplay=1'
                    },
                    vimeo: {
                        index: 'vimeo.com/',
                        id: function(url) {
                            var m = url.match(/(https?:\/\/)?(www.)?(player.)?vimeo.com\/([a-z]*\/)*([0-9]{6,11})[?]?.*/);
                            if ( !m || !m[5] ) return null;
                            return m[5];
                        },
                        src: '//player.vimeo.com/video/%id%?autoplay=1'
                    }
                }
            },
    		callbacks: {
    			//pause any background videos when the popup opens, resume when it closes
    			open: function () {
    				var videos = $("video");
                    $('body').addClass('mfp-open');

    				videos.each(function () {
    					var video = $(this),
    						videoElem = video.get(0);

    					//don't pause the mfp video
    					if (video.closest(".mfp-wrap").length === 0) {

    						//if video is playing
    						if (!videoElem.paused && !videoElem.ended) {
    							video.attr("data-was-playing", true);
    							videoElem.pause();
    						}
    					}
    				});
    			},
    			//resume any background videos when the popup opens, resume when it closes
    			close: function () {
    				var videos = $("video[data-was-playing=true]");
                    $('body').removeClass('mfp-open');

    				videos.each(function () {
    					var video = $(this),
    						videoElem = video.get(0);

    					//don't resume the mfp video
    					if (video.closest(".mfp-wrap").length === 0) {

    						videoElem.play();
    					}
    				});
    			}
    		}
    	});
    }

    function allQuestionsAnswered(slide) {
        let questions    = $(slide).find('select'),
            allAnswered  = true;

        for (let i = 0; i < questions.length; i++) {
            if (!($(questions[i]).val())) {
                allAnswered = false;
                break;
            }
        }

        return allAnswered;
    }

	// Slick Sliders
    $('.slick-slider').each(function () {
        var id = $(this).attr('id');

        if(id && id.includes('image-slider')) {
            $(this).slick({
                accessibility: true,
                autoplay: false,
                arrows: true,
                prevArrow: $('#' + id + '-arrow-prev'),
                nextArrow: $('#' + id + '-arrow-next'),
                dots: false,
                adaptiveHeight: false,
                cssEase: 'ease-out',
                slidesToShow: 1,
                infinite: true,
                slidesToScroll: 1,
                speed: 300,
                rows: 0
            });

        } else if(id && id.includes('question-slider')) {
            $(this).slick({
                accessibility: false,
                swipe: false,
                touchMove: false,
                draggable: false,
                autoplay: false,
                arrows: true,
                prevArrow: $('#' + id + '-prev'),
                nextArrow: $('#' + id + '-next'),
                dots: false,
                adaptiveHeight: true,
                cssEase: 'ease-out',
                slidesToShow: 1,
                infinite: false,
                slidesToScroll: 1,
                speed: 300,
                rows: 0
            });

            var stepProgress = $(this).data('step-progress'),
                stepCount = $(this).data('step-count'),
                stepCircle = $('#slider-step-circle'),
                stepSpan = $('#slider-step'),
                progressBar = $('#progress-bar'),
                nextButton = $('#' + id + '-next'),
                prevButton = $('#' + id + '-prev'),
                resultsWrapper = $('#results-wrapper');

            // hide the results wrapper on load
            // not sure if this is necessary - should be empty on load anyway
            $(resultsWrapper).hide();

            // set the first slide's inputs to tabindex="0"
            $(this).find('.slide').first().find('input, select, textarea').attr('tabindex', '0');

            $(this).on('beforeChange', function(event, slick, currentSlide, nextSlide) {
                var $currentSlide   = $(slick.$slides[currentSlide]),
                    $nextSlide      = $(slick.$slides[nextSlide]),
                    $previousSlides = $(),
                    currentStep     = currentSlide + 1;

                // set the next button as disabled (remove disabled after an answer is selected)
                $(nextButton).prop('disabled', !allQuestionsAnswered(slick.$slides[nextSlide]));

                // set the current slide inputs to tabindex="-1"
                $currentSlide.find('input, select, textarea').attr('tabindex', '-1');

                if(currentStep == stepCount - 1) {
                    $(this).trigger('uws-question-slider:show-results');
                } else {
                    $(this).trigger('uws-question-slider:hide-results');
                }

                //if not path slider, do nothing further
                if (id !== 'path-question-slider') {
                    return;
                }

                //if going backwards, do nothing further
                if (nextSlide < currentSlide) {
                    return;
                }

                //filter allowed choices for next question
                for (let i = 0; i < nextSlide; i++) {
                    $previousSlides = $previousSlides.add(slick.$slides[i]);
                }

                //enable/disable answers according to disallowed combinations data
                var answers = {},
                    questions = [];

                $previousSlides.find('select, input[type="checkbox"]').each(function () {
                    if ($(this).is('input[type="checkbox"]')) {
                        answers[$(this).val()] = $(this).is(':checked') ? 'Y' : 'N';
                    } else {
                        answers[$(this).attr('name')] = $(this).val();
                    }
                });

                questions = Object.keys(answers);

                $nextSlide.find('select option').show().prop('selected', false).closest('select').val('');
                $nextSlide.find('input[type="checkbox"]').prop('checked', false).closest('label').show();

                if (nextSlide == 1) {
                    if (answers['previous_education'] == 'high_school' || answers['previous_education'] == 'some_college') {
                        $nextSlide.find('select option').each(function () {
                            let val = $(this).attr('value');

                            if (val == '') {
                                return;
                            }

                            if (!['associate', 'bachelor', 'non_degree'].includes(val)) {
                                $(this).hide();
                            }
                        });
                    } else if (answers['previous_education'] == 'associate') {
                        $nextSlide.find('select option').each(function () {
                            let val = $(this).attr('value');

                            if (val == '') {
                                return;
                            }

                            if (!['bachelor', 'non_degree'].includes(val)) {
                                $(this).hide();
                            }
                        });
                    } else if (answers['previous_education'] == 'bachelor') {
                        $nextSlide.find('select option').each(function () {
                            let val = $(this).attr('value');

                            if (val == '') {
                                return;
                            }

                            if (!['bachelor', 'master', 'doctorate', 'non_degree', 'education_specialist'].includes(val)) {
                                $(this).hide();
                            }
                        });
                    } else if (answers['previous_education'] == 'master') {
                        $nextSlide.find('select option').each(function () {
                            let val = $(this).attr('value');

                            if (val == '') {
                                return;
                            }

                            if (!['master', 'doctorate', 'non_degree', 'education_specialist'].includes(val)) {
                                $(this).hide();
                            }
                        });
                    }
                } else if (nextSlide == 3) {
                    if (answers['previous_education'] == 'high_school') {
                        $nextSlide.find('input[type="checkbox"]').each(function () {
                            let val = $(this).val();

                            if (!['non_us_citizen', 'veteran'].includes(val)) {
                                $(this).closest('label').hide();
                            }
                        });
                    } else if (answers['previous_education'] == 'some_college' && answers['degree_type'] == 'non_degree') {
                        $nextSlide.find('input[type="checkbox"]').each(function () {
                            let val = $(this).val();

                            if (!['non_us_citizen', 'veteran'].includes(val)) {
                                $(this).closest('label').hide();
                            }
                        });
                    }
                }
            });

            $(this).on('change', '.slick-active select', function (e) {

                let currentSlide = $(e.target).closest('.slick-active');

                if (allQuestionsAnswered(currentSlide)) {
                    nextButton.prop('disabled', false);
                } else {
                    nextButton.prop('disabled', true);
                }
            });

            $(this).on('afterChange', function(event, slick, currentSlide) {
                var $currentSlide   = $(slick.$slides[currentSlide]),
                    currentStep = currentSlide + 1,
                    //currentProgress = (100 * (stepProgress * currentStep));
                    currentProgress = stepProgress * currentStep;

                // set the current step in the appropriate areas
                $(stepSpan).text(currentStep);

                if(currentStep < 10) {
                    $(stepCircle).text('0' + currentStep);
                } else {
                    $(stepCircle).text(currentStep);
                }

                // set the current progress to the progress bar
                if(currentStep == stepCount) {
                    $(progressBar).css('width', '100%');
                } else {
                    $(progressBar).css('width', currentProgress + '%');
                }

                // hide the back button on first step
                if(currentSlide == 0) {
                    $(prevButton).addClass('hidden');
                } else {
                    $(prevButton).removeClass('hidden');
                }

                // hide the next button on last step
                // hide the results wrapper until the next step
                if(currentStep == stepCount) {
                    $(nextButton).addClass('hidden');
                    $(resultsWrapper).show();
                } else {
                    $(nextButton).removeClass('hidden');
                    $(resultsWrapper).hide();
                }

                // set the current slide inputs to tabindex="0"
                $currentSlide.find('input, select, textarea').attr('tabindex', '0');

                //ensure contents of slide aren't scrolled off the top of the window
                setTimeout(function () {
                    let finder = $currentSlide.closest('.finder'),
                        finderOffset = finder.offset().top,
                        scrollTop    = $(window).scrollTop(),
                        finderPos    = finderOffset - scrollTop;

                    if (finderPos < 0) {
                        $('html,body').animate({
                            scrollTop: (finderOffset - 20)
                        }, 50, 'linear');
                    }
                }, 100);
            });

        } else {
            $(this).slick({
                accessibility: true,
                autoplay: false,
                nextArrow: $('#' + id +'-arrow-next'),
                prevArrow: $('#' + id +'-arrow-prev'),
                cssEase: 'ease-out',
                dots: false,
                speed: 250
            });
        }
    });

	// global function for smooth scrolling
    function smoothScroll(target, offset, speed) {
        $('html,body').animate({
            scrollTop: (target.offset().top - offset)
        }, speed);
    }

    // General Smooth Scrolling with no offset
    $('.smooth-scroll').each(function() {
        $(this).on('click', function (e) {
            e.preventDefault();
            var target = $(this).data('target');
			var offset;

			if ($(this).data('offset')) {
			    offset = $(this).data('offset');
			} else {
				if(lgMin) {
					offset = 0;
				} else {
					offset = 0;
				}
			}

			// add hash to URL
            // if (target) {
            //     window.location.hash = target;
            // }

            smoothScroll($(target), offset, 0);
        });
    });

    // Scroll Magic Tweens & Parallax

    // init controller
    var controller = new ScrollMagic.Controller();

    // standard y parallax images
	$('.parallax-window').each(function(index) {
        var triggerWindow = '#window-' + index,
            standardTween,
            image = triggerWindow + ' .parallax-element',
            scene;

        $(this).attr('id', triggerWindow.slice(1));

		if(!mobileCheck()) {
			// build tween
	        standardTween = TweenMax.to(triggerWindow + ' .parallax-element', 1, {y: '80%', ease: Linear.easeNone});

	        // build scene
	        scene = new ScrollMagic.Scene({
	            triggerElement: triggerWindow,
	            triggerHook: 'onEnter',
	            duration: '200%'
	        })
	        .setTween(standardTween)
	        .addTo(controller);

	        // tell image that parallax function ran
	        $(image).addClass('parallax-js-loaded');
		} else {
			$(image).css('transform','none');
		}
    });


    // map UI hover effects
    $('.map-dot').each(function() {
        var id = $(this).attr('id'),
            link = '#' + id.replace('dot-', '');

        $(this).on({
            mouseenter: function () {
                $(link).addClass('hover');
            },
            mouseleave: function () {
                $(link).removeClass('hover');
            }
        });
    });

    $('.map-list-uni-link').each(function() {
        var uni = $(this).data('uni'),
            mapLink = '#' + uni,
            mapDot = '#dot-' + uni;

        $(this).on({
            mouseenter: function () {
                $(mapLink).addClass('hover');
                $(mapDot).addClass('hover');
            },
            mouseleave: function () {
                $(mapLink).removeClass('hover');
                $(mapDot).removeClass('hover');
            }
        });
    });
});


/*
jQuery(window).on('load', function() {
    console.log('loaded');
    jQuery('html').addClass('js-window-loaded');
});
*/
